import { appBase, localAsset } from './basePath';

const CONSTANTS = {
  host: 'velodrom.dreambikebuilder.com',
  imageBase: appBase,
  framesets: {
    title: 'Frameset',
    zIndex: 5,
    scale: 1.2
  },
  bars: {
    title: 'Bars/Stem',
    zIndex: 6,
    scale: .32
  },
  groupsets: {
    title: 'Groupset',
    zIndex: 10,
    scale: .25
  },
  groupsetsLeft: {
    zIndex: 4,
    scale: .3
  },
  groupsetsMiddle: {
    zIndex: 10,
    scale: .27
  },
  groupsetsBar: {
    zIndex: 7,
    scale: .45
  },
  groupsetsBrakeLeft: {
    zIndex: 2,
    scale: .25
  },
  groupsetsBrakeRight: {
    zIndex: 2,
    scale: .25
  },
  groupsetsCapilierLeft: {
    zIndex: 3,
    scale: .13
  },
  groupsetsCapilierRight: {
    zIndex: 4,
    scale: .13
  },
  groupsetsGear: {
    zIndex: 11,
    scale: .28
  },
  wheels: {
    title: 'Wheels',
    zIndex: 1,
    scale: .95
  },
  tyres: {
    title: 'Tyres',
    zIndex: 2,
    scale: .95
  },
  seatposts: {
    title: 'Seatposts',
    zIndex: 2,
    scale: .36
  },
  saddles: {
    title: 'Saddles',
    zIndex: 7,
    scale: .3
  },
  cages: {
    title: 'Bottle Cages',
    zIndex: 6,
    scale: .25
  },
  // Pedal artwork is drawn at 4 source px/mm; cranks are .70 logical px/mm.
  pedals: {
    title: 'Pedals',
    zIndex: 10.8,
    scale: .175
  }
};

export { CONSTANTS };

// Steps whose cards can be narrowed by category, and the choices offered.
const CATEGORY_STEPS = ['Frameset', 'Groupset', 'Tyres', 'Pedals'];
export function categoryOptions(type) {
  if (!CATEGORY_STEPS.includes(type)) return [];
  if (type === 'Groupset') return [
    { text: 'All', value: 'All' },
    { text: '1X Speed', value: 'Gravel' },
    { text: '2X Speed', value: 'Road' }
  ];
  return [
    { text: 'All', value: 'All' },
    { text: 'Road', value: 'Road' },
    { text: 'Gravel', value: 'Gravel' }
  ];
}

export function imageUrl(url) {
  let value = (url || '').trim();
  if (!value) return '';
  // Legacy catalogue URLs are identifiers for our own asset archive now.
  // Never fall back to fetching these hosts in a customer's browser.
  if (/^(?:https?:)?\/\/(?:velodrom\.dreambikebuilder\.com|bikebuilder\.inmovens\.com)(?:[/:]|$)/i.test(value)) {
    try { const legacy = new URL(value, window.location.origin); value = legacy.pathname + legacy.search; }
    catch (_) { return ''; }
  }
  if (/^(?:https?:|data:|blob:|\/\/)/i.test(value)) return value;
  if (value.startsWith('/bikebuilder/')) return value;
  if (/^\/(?:uploads|resources)\//.test(value)) return localAsset(value);
  return appBase + '/' + value.replace(/^\/+/, '');
}

const decodedImages = new Map();
const MAX_DECODED_IMAGES = 32;

export function loadImage(url) {
  const source = imageUrl(url);
  if (!source) return Promise.resolve(null);
  if (decodedImages.has(source)) {
    const cached = decodedImages.get(source);
    decodedImages.delete(source);
    decodedImages.set(source, cached);
    return cached;
  }
  const pending = new Promise(resolve => {
    const image = new Image();
    const finish = value => {
      clearTimeout(timer);
      image.onload = image.onerror = null;
      if (!value && decodedImages.get(source) === pending) decodedImages.delete(source);
      resolve(value);
    };
    const timer = setTimeout(() => finish(null), 15000);
    // Decode off the main thread so the first canvas draw (and its
    // animation) does not stall on large PNG cutouts. decode() can wait
    // indefinitely in a hidden tab, so never let it hold the image back.
    image.onload = () => Promise.race([
      image.decode ? image.decode().catch(() => {}) : null,
      new Promise(done => setTimeout(done, 1200))
    ]).then(() => finish(image));
    image.onerror = () => finish(null);
    image.src = source;
  });
  decodedImages.set(source, pending);
  if (decodedImages.size > MAX_DECODED_IMAGES) decodedImages.delete(decodedImages.keys().next().value);
  return pending;
}

export function containImage(image, width, height, container, dim = {}) {
  if (image) {

    container = container || image.parentNode;
    const WIDTH = dim.containerWidth || container.clientWidth;
    const HEIGHT = dim.containerHeight || container.clientHeight;
    const REL = WIDTH / HEIGHT;
    const rel = width / height;

    if (REL > rel) {

      var h = Math.min(HEIGHT, height);
      image.style.height = h + 'px';
      image.style.width = (h * rel) + 'px';

    } else {

      var w = Math.min(WIDTH, width);
      image.style.width = w + 'px';
      image.style.height = (w / rel) + 'px';

    }
  }
}

export function toArray(value) {
  if (value == null) return [];
  if (typeof value !== 'string' && typeof value.length === 'number')
    return Array.prototype.slice.call(value);
  return [value];
}

export function itemImage(item, index) {
  index = index || 0;
  const image = { src: '', front: '', thumb: '' };
  if (item && item.colors[index]) {

    const colorObj = item.colors[index].color;
    image.thumb = item.thumbnail;

    // Check for custom base64 image
    if (colorObj.customImage) {
      // Did not set front so sidebar falls back to thumb (frameset thumbnail)
      image.src = colorObj.customImage;
    } else {
      image.front = colorObj.imageFront;
      image.src = colorObj.image;
    }

    for (const img in image) image[img] = imageUrl(image[img]);
  }
  return image;
}

export function capitalize(str) {
  str = String(str);
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç";
const to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";
const map = {};

for (var i = 0, j = from.length; i < j; i++)
  map[from.charAt(i)] = to.charAt(i);

export const normalize = str => {
  var ret = [];
  for (var i = 0, j = str.length; i < j; i++) {
    var c = str.charAt(i);
    // eslint-disable-next-line
    if (map.hasOwnProperty(c)) ret.push(map[c]);
    else ret.push(c);
  }
  return ret.join('').toLowerCase();
}

// COLOR FUNCTIONS

function add(color, amount) {
  color = parseInt(color, 16) + amount;
  color = Math.max(Math.min(color, 255), 0).toString(16);
  return color.length > 1 ? color : ('0' + color);
}

function transformColor(color, amount) {
  color = color.replace('#', '');
  amount = parseInt((255 * amount) / 100);
  return '#' + [
    add(color.substring(0, 2), amount),
    add(color.substring(2, 4), amount),
    add(color.substring(4, 6), amount)
  ].join('')
}

export function lighten(color, amount) {
  return transformColor(color, amount);
}

export function darken(color, amount) {
  return transformColor(color, -amount);
}

export function toCamel(obj) {
  const newObj = {};
  const MAP = {
    'bar_position_x': 'barX',
    'bar_position_y': 'barY',
    'wheel_right_x': 'rightWheelX',
    'wheel_right_y': 'rightWheelY',
    'wheel_left_x': 'leftWheelX',
    'wheel_left_y': 'leftWheelY',
    'groupset_capilier_rear_x': 'groupsetCapilierRearX',
    'groupset_capilier_rear_y': 'groupsetCapilierRearY',
    'groupset_capilier_front_x': 'groupsetCapilierFrontX',
    'groupset_capilier_front_y': 'groupsetCapilierFrontY',
    'groupset_capilier_middle_x': 'groupsetCapilierMiddleX',
    'groupset_capilier_middle_y': 'groupsetCapilierMiddleY',
  };

  // Default Enabled flags (Optional, matching server logic)
  // newObj.barEnabled = true; // Avoid defaults if we want strict DB values

  for (const key in obj) {
    let newKey = MAP[key];
    if (!newKey) {
      newKey = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
    }
    newObj[newKey] = obj[key];
  }

  // Explicit overrides
  if (obj.custom_image) newObj.customImage = obj.custom_image;

  return newObj;
}
